export default function MarqueeStrip() {
  const items = Array(12).fill('EDUCATION OF THE FUTURE');
  return (
    <div className="bg-yellow-400 py-4 overflow-hidden">
      <div className="flex animate-marquee whitespace-nowrap">
        {items.map((t, i) => (
          <span key={i} className="text-gray-900 font-extrabold text-sm uppercase tracking-widest mx-8 flex-shrink-0 font-syne">
            {t} <span className="mx-2 text-gray-700">✦</span>
          </span>
        ))}
        {items.map((t, i) => (
          <span key={`d-${i}`} className="text-gray-900 font-extrabold text-sm uppercase tracking-widest mx-8 flex-shrink-0 font-syne">
            {t} <span className="mx-2 text-gray-700">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
